import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export default function useAlert() {
  const alert = withReactContent(Swal);

  const successAlert = (title, options = {}) => {
    return alert.fire({
      title,
      icon: "success",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      ...options,
    });
  };

  const errorAlert = (title, options = {}) => {
    return alert.fire({
      title,
      icon: "error",
      showCloseButton: true,
      showConfirmButton: false,
      ...options,
    });
  };

  const confirmAlert = (title, options = {}) => {
    return alert.fire({
      title,
      icon: "warning",
      confirmButtonText: "Yes, save it!",
      confirmButtonColor: "#0576B9",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      cancelButtonColor: "#9599AD",
      ...options,
    });
  };

  const okAlert = (title, options = {}) => {
    return alert.fire({
      title,
      icon: "success",
      confirmButtonText: "Go to Preview",
      confirmButtonColor: "#0576B9",
      showCancelButton: false,
      allowOutsideClick: true,
      ...options,
    });
  };

  const confirmWorkflowChangeStatus = (options = {}) => {
    return alert.fire({
      showCancelButton: true,
      cancelButtonText: `
            <span style="display:flex; align-items:center; gap:12px;">
                <i style="font-size:20px" class="fas fa-ban"></i>
                <span>No</span>
            </span>
            `,
      confirmButtonText: `
                <span style="display:flex; align-items:center; gap:12px;">
                <i style="font-size:20px" class="fas fa-check"></i>
                <span>Yes</span>
                </span>
            `,
      confirmButtonColor: "#0576B9",
      iconColor: "#F56E50",
      reverseButtons: true,
      icon: "question",
      ...options,
    });
  };

  const confirmBulkWorkflowChangeStatus = (html, options = {}) => {
    return alert.fire({
      html,
      showCancelButton: true,
      cancelButtonText: `
            <span style="display:flex; align-items:center; gap:12px;">
                <i style="font-size:20px" class="fas fa-ban"></i>
                <span>No</span>
            </span>
            `,
      confirmButtonText: `
                <span style="display:flex; align-items:center; gap:12px;">
                <i style="font-size:20px" class="fas fa-check"></i>
                <span>Yes, continue</span>
                </span>
            `,
      confirmButtonColor: "#0576B9",
      iconColor: "#F56E50",
      reverseButtons: true,
      icon: "question",
      ...options,
    });
  }

  const toast = (content, icon = "info") => {
    alert.fire({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      icon,
      html: content,
    });
  };

  return {
    successAlert,
    errorAlert,
    confirmAlert,
    okAlert,
    confirmWorkflowChangeStatus,
    toast,
    confirmBulkWorkflowChangeStatus,
  };
}
